(function () {
	'use strict';

	function init() {
		const triggers = document.querySelectorAll('.js-primary-menu-item');
		const dropdownSelector = '.js-primary-menu-dropdown';

		triggers.forEach((trigger) => {
			const dropdown = trigger.querySelector(dropdownSelector);

			const dropdownWidth = dropdown.offsetWidth;
			const triggerRect = trigger.getBoundingClientRect();

			const wouldOverflow = triggerRect.right + dropdownWidth > window.innerWidth;

			if (wouldOverflow) {
				dropdown.classList.add('from-right');
			} else {
				dropdown.classList.remove('from-right');
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
